/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const modelUrl = process.env.REACT_APP_MODELPATH+"waterlight2.glb";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(modelUrl);
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object558.geometry}
        material={nodes.Object558.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object559.geometry}
        material={nodes.Object559.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object560.geometry}
        material={nodes.Object560.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object561.geometry}
        material={nodes.Object561.material}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Object562.geometry}
        material={nodes.Object562.material}
      />
    </group>
  );
}

useGLTF.preload(modelUrl);
